import { TransactionStatus, PaymentMethod } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';

export class TransactionModel extends Model {
  public TransactionDate!: string;
  public Date?: string;
  public Value!: number;
  public Currency!: string;
  public AuthorizationCode!: string;
  public Nsu!: string;
  public Tid!: string;
  public Message!: string;
  public Status!: TransactionStatus;
  public CardTruncatedNumber!: string;
  public PaymentMethod!: PaymentMethod;
  public ExpirationDate?: string;
  public Output!: string;
  public Input!: string;

  public Covenant!: {
    Id: string;
    Active: boolean;
    Code: string;
  };

  public Return!: {
    Id: string;
    Description: string;
    Code: string;
  };
}
